//
// GENERATED by KVision
//
package pl.finn.forms.teryt

import io.kvision.remote.HttpMethod
import io.kvision.remote.KVServiceManager
import io.kvision.remote.registerKVisionServiceExceptions

expect class TerytApiService : ITerytApiService

object TerytApiServiceManager : KVServiceManager<TerytApiService>(TerytApiService::class) {
    init {
        registerKVisionServiceExceptions()
        bind(ITerytApiService::addresses, HttpMethod.POST, null)
        bind(ITerytApiService::voivodeships, HttpMethod.POST, null)
        bind(ITerytApiService::countries, HttpMethod.POST, null)
        bind(ITerytApiService::communities, HttpMethod.POST, null)
        bind(ITerytApiService::localities, HttpMethod.POST, null)
        bind(ITerytApiService::streets, HttpMethod.POST, null)
    }
}
